import { ThemeUICSSObject } from '@apia/theme';
import gridEdition from './overlayClassnames/gridEdition';

const overlay: Record<string, ThemeUICSSObject> = {
  overlay: {
    ...gridEdition,
  },
};

export default overlay;
